import { Injectable, inject } from '@angular/core';
import { IocSelectorComponent } from './ioc-selector.component';
import { PopoverController } from '@ionic/angular';

export interface IocSelectorOption {
  label: string,
  value: any
}

@Injectable({
  providedIn: 'root'
})

export class IocSelectorService {
  private popoverController = inject(PopoverController);

  constructor() { }

  async openPopover(title: string, iocSelectorOptions: IocSelectorOption[], showCancelButton: boolean): Promise<any> {
    const popover = await this.popoverController.create({
      component: IocSelectorComponent,
      componentProps: {
        title,
        iocSelectorOptions,
        showCancelButton,
      },
      cssClass: 'mt-popover',
      backdropDismiss: showCancelButton,
      translucent: false,
    });
  
    await popover.present();
    
    const { data } = await popover.onDidDismiss();
    
    if (!data || data.isCanceled) {
      return;
    }
  
    return data;
  }
}

